'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var utilityFunctions = require('../../utilityFunctions.js');

var AnchorMenu = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.classWhenFixed, classWhenFixed = _c === void 0 ? '' : _c, _d = _a.classWhenNotFixed, classWhenNotFixed = _d === void 0 ? '' : _d, _e = _a.fixedTopOffset, fixedTopOffset = _e === void 0 ? 0 : _e, _f = _a.lastOffset, lastOffset = _f === void 0 ? 0 : _f, _g = _a.navs, navs = _g === void 0 ? [] : _g, _h = _a.scrollPaddingFactor, scrollPaddingFactor = _h === void 0 ? 100 : _h, _j = _a.unfixedTopOffset, unfixedTopOffset = _j === void 0 ? 0 : _j;
    var SUB_NAV_BAR_HEIGHT = 58;
    var ref = react.useRef(null);
    var _k = react.useState(''), positionClass = _k[0], setPositionClass = _k[1];
    var _l = react.useState(''), activeId = _l[0], setActiveId = _l[1];
    react.useEffect(function () {
        var handleNavBarPosition = function () {
            if (ref.current) {
                if (utilityFunctions.isPageScrolledPastTopOfElement(ref.current.parentElement, fixedTopOffset)) {
                    setPositionClass("fixed-top ".concat(classWhenFixed));
                }
                else {
                    setPositionClass(classWhenNotFixed);
                }
            }
        };
        var isSectionActive = function (section) {
            return utilityFunctions.isPageScrolledPastTopOfElement(section, scrollPaddingFactor + fixedTopOffset) && !utilityFunctions.isPageScrolledPastBottomOfElement(section, fixedTopOffset);
        };
        var highlightActiveSection = function (sections) {
            var areAnySectionActive = false;
            var lastSection = sections[sections.length - 1];
            // If at bottom of screen, highlight the last nav
            if (utilityFunctions.isPageAtBottom() && lastSection) {
                setActiveId(lastSection.id);
                areAnySectionActive = true;
            }
            else {
                sections.forEach(function (section) {
                    var node = document.getElementById(section.id);
                    if (node && isSectionActive(node)) {
                        setActiveId(section.id);
                        areAnySectionActive = true;
                    }
                });
            }
            // clear active id if no sections are currently active
            if (!areAnySectionActive) {
                setActiveId(null);
            }
        };
        // TODO: When you click on a nav item and the page is all the way at the bottom,
        // the last element is highlighted and not necessarily the one you clicked on
        var handleScroll = function () {
            handleNavBarPosition();
            highlightActiveSection(navs);
        };
        window.addEventListener('scroll', handleScroll);
        // componentWillUnmount
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, [
        ref,
        navs,
        setActiveId,
        classWhenFixed,
        classWhenNotFixed,
        scrollPaddingFactor
    ]);
    var isActiveItem = function (id) {
        return id && activeId && id === activeId ? "active" : '';
    };
    var getNavItems = function (items) {
        return items.map(function (nav, index) { return (jsxRuntime.jsx("li", tslib.__assign({ className: "d-flex nav-item m-0" }, { children: jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ role: "button", buttonType: "light", className: "w-100 text-uppercase pt-3 pb-3 ".concat(isActiveItem(nav.id)), onClick: function () {
                    var offset = positionClass.includes('fixed-top')
                        ? SUB_NAV_BAR_HEIGHT
                        : SUB_NAV_BAR_HEIGHT * 2 + unfixedTopOffset;
                    if (index === navs.length - 1) {
                        offset += lastOffset;
                    }
                    utilityFunctions.scrollToSection("".concat(nav.id), offset + fixedTopOffset);
                } }, { children: nav.title })) }), nav.id)); });
    };
    return (jsxRuntime.jsx("div", { children: jsxRuntime.jsx("div", tslib.__assign({ ref: ref, className: "".concat(className, " ").concat(positionClass), role: "navigation" }, { children: jsxRuntime.jsx("ul", tslib.__assign({ className: "nav nav-fill flex-nowrap" }, { children: getNavItems(navs) })) })) }));
};
var AnchorMenu$1 = AnchorMenu;

exports.default = AnchorMenu$1;
//# sourceMappingURL=AnchorMenu.js.map
